import { Controller } from "stimulus"
import Cleave from 'cleave.js';

export default class extends Controller {

  static targets = [ "residueType", "collectionUnits", "samplingItems", "totalWeight" ]

  connect() {
    if (document.body.getAttribute("data-action").includes("edit") || document.body.getAttribute("data-action").includes("update")) {
      if (this.residueTypeTarget.options[this.residueTypeTarget.selectedIndex].textContent == "Recicláveis") {
        this.samplingItemsTarget.classList.remove("is-display-none")
        this.totalWeightTarget.classList.add("is-display-none")
        document.querySelector(".add-item").classList.remove("is-display-none")
      } else {
        this.samplingItemsTarget.classList.add("is-display-none")
        this.totalWeightTarget.classList.remove("is-display-none")
        document.querySelector(".add-item").classList.add("is-display-none")
      }
    }

    if (document.body.getAttribute("data-action").includes("new") || document.body.getAttribute("data-action").includes("create") || document.body.getAttribute("data-action").includes("edit") || document.body.getAttribute("data-action").includes("update")) {
      var cleave = new Cleave(".input-date", {
        date: true,
        datePattern: ["d", "m", "Y"]
      })
    }
  }

  // Change residue type and return collection units
  changeResidueType(event) {
    var collectionUnitsTarget = this.collectionUnitsTarget
    if (event.currentTarget.value == "") {
      collectionUnitsTarget.options.length = 1
    } else {
      fetch("/unidades-de-coleta/" + event.currentTarget.value).then(
        function(response) {
          return response.json().then(function(json) {
            collectionUnitsTarget.options.length = 1
            for (var i = 0; i < json.length; i++) {
              var option = document.createElement("option")
              option.appendChild(document.createTextNode(json[i]["name"]))
              option.value = json[i]["_id"]["$oid"]
              collectionUnitsTarget.appendChild(option)
            }
          })
        }
      )
    }
    if (event.target.selectedOptions[0].textContent == "Recicláveis") {
      this.samplingItemsTarget.classList.remove("is-display-none")
      this.totalWeightTarget.classList.add("is-display-none")
      document.querySelector(".add-item").classList.remove("is-display-none")
    } else {
      this.samplingItemsTarget.classList.add("is-display-none")
      this.totalWeightTarget.classList.remove("is-display-none")
      document.querySelector(".add-item").classList.add("is-display-none")
    }
  }

  addItem(event) {
    var divFlex = document.createElement("div")
    divFlex.classList.add("flex")
    divFlex.classList.add("ai-center")
    divFlex.classList.add("item")
    var formGroup1 = document.createElement("div")
    formGroup1.classList.add("flex-item")
    formGroup1.classList.add("form-group")
    var label1 = document.createElement("label")
    label1.appendChild(document.createTextNode("Resíduo"))
    label1.setAttribute("id", "sampling_sampling_items_attributes_" + document.querySelectorAll(".item").length + "_residue")
    label1.setAttribute("name", "sampling[sampling_items_attributes]["+ document.querySelectorAll(".item").length +"][residue]")
    var span1 = document.createElement("span")
    span1.appendChild(document.createTextNode("Tipo de reciclável"))
    label1.appendChild(span1)
    formGroup1.appendChild(label1)
    var select = document.createElement("select")
    select.setAttribute("id", "sampling_sampling_items_attributes_" + document.querySelectorAll(".item").length + "_residue")
    select.setAttribute("name", "sampling[sampling_items_attributes]["+ document.querySelectorAll(".item").length +"][residue]")
    let options = document.getElementById("sampling_sampling_items_attributes_0_residue").options
    for ( var i = 0; i < options.length; i++ ) {
      var option = document.createElement("option")
      option.value = options[i].value
      option.text = options[i].text
      select.add(option)
    }
    formGroup1.appendChild(select)

    var formGroup2 = document.createElement("div")
    formGroup2.classList.add("flex-item")
    formGroup2.classList.add("form-group")
    var label2 = document.createElement("label")
    label2.appendChild(document.createTextNode("Peso (kg)"))
    label2.setAttribute("id", "sampling_sampling_items_attributes_" + document.querySelectorAll(".item").length + "_weight")
    label2.setAttribute("name", "sampling[sampling_items_attributes]["+ document.querySelectorAll(".item").length +"][weight]")
    var span2 = document.createElement("span")
    span2.appendChild(document.createTextNode("Peso do material"))
    label2.appendChild(span2)
    var input2 = document.createElement("input")
    input2.setAttribute("type", "text")
    input2.setAttribute("id", "sampling_sampling_items_attributes_" + document.querySelectorAll(".item").length + "_weight")
    input2.setAttribute("name", "sampling[sampling_items_attributes]["+ document.querySelectorAll(".item").length +"][weight]")
    formGroup2.appendChild(label2)
    formGroup2.appendChild(input2)
    var a = document.createElement("a")
    a.setAttribute("href", "#")
    a.setAttribute("data-action", "application#preventDefault samplings#removeItem")
    var i = document.createElement("i")
    i.classList.add("icon")
    i.classList.add("icon-waste-recycling")
    i.setAttribute("title", "Excluir")
    a.appendChild(i)
    divFlex.appendChild(formGroup1)
    divFlex.appendChild(formGroup2)
    divFlex.appendChild(a)
    this.samplingItemsTarget.append(divFlex)
  }

  removeItem(event) {
    event.currentTarget.parentNode.remove()
  }
}
